import { type UseQueryOptions, type UseQueryResult, useQuery } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { loadYandexMapScriptService } from './internal/fetchService';

export function useGetYandexMapScriptQuery<TData = YMaps.IYMaps>(
  options?: UseQueryOptions<YMaps.IYMaps, QueryError, TData, QueryKey>,
): UseQueryResult<TData, QueryError> {
  const context = useQueryStateAppContext();

  return useQuery<YMaps.IYMaps, QueryError, TData, QueryKey>({
    queryFn: () => loadYandexMapScriptService(context),
    queryKey: getQueryKey(),
    retry: false,
    ...options,
  });
}
